import { injectable } from 'inversify';
import { createBrowserHistory, Location, LocationState, Path } from 'history';

@injectable()
export class RouterStore {
    history = createBrowserHistory();
    location!: Location;

    skipScrollOnNextRouteChange = false;

    pushNoScroll = (path: Path, state?: LocationState) => {
        this.skipScrollOnNextRouteChange = true;
        this.history.push(path, state);
    };

    replaceNoScroll = (path: Path, state?: LocationState) => {
        this.skipScrollOnNextRouteChange = true;
        this.history.replace(path, state);
    };
}
